import script from "./CurrentDateIncineratedChart.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentDateIncineratedChart.vue?vue&type=script&setup=true&lang=js"

import "./CurrentDateIncineratedChart.vue?vue&type=style&index=0&id=66e46648&lang=css"

const __exports__ = script;

export default __exports__